/* eslint-disable import/order */
import InnerHeader from './InnerHeader';
import BasicSetup from '../../BasicSetup';
import GlobalStyles from '../../GlobalStyles';

interface IHeaderProps {}

const Header: React.FC<IHeaderProps> = () => (
  <BasicSetup>
    <InnerHeader />
    <GlobalStyles />
  </BasicSetup>
);

export default Header;
